import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import SVG from "@/assets/svg";
import CostumeButton from "@/component/button";
import { DialogueStyled } from "../dialogueStyled";

interface ITrainingRecordsModelInterFace {
  onClose: () => void;
  handleDelete?: () => void | Promise<void>;
  title?: string;
  message?: string;
  btnTitle?: string;
  loading?: boolean;
}
function ConfirmDelete({
  onClose,
  handleDelete,
  title,
  message,
  loading,
  btnTitle,
}: ITrainingRecordsModelInterFace) {
  return (
    <DialogueStyled>
      <div>
        <Box className="delete">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "19px",
            }}
          >
            <Typography id="modal-modal-title" variant="h3">
              Are you sure?
            </Typography>
            <Box>
              <SVG.Cross onClick={onClose} />
            </Box>
          </Box>

          <Box className="delete-confirm-msg">
            {message || title || "This action cannot be reversed once done"}
          </Box>

          <Box
            sx={{
              right: "20px",
              display: "flex",
              position: "absolute",
              bottom: "15px",
            }}
          >
            {" "}
            <CostumeButton onClick={onClose} className="Cancel">
              Cancel
            </CostumeButton>
            <CostumeButton
              className="Delete"
              loading={loading}
              onClick={async () => await handleDelete?.()}
            >
              {btnTitle || "Delete"}
            </CostumeButton>
          </Box>
        </Box>
      </div>
    </DialogueStyled>
  );
}

export default ConfirmDelete;
